<template>
  <v-data-table
    :headers="tableHeaders"
    :items="filteredProducts"
    multi-sort
    item-key="name"
    :expanded.sync="expanded"
    :single-expand="singleExpand"
    :footer-props="{ itemsPerPageOptions: [10, 20, 50] }"
    :options.sync="options"
    no-data-text="Nenhum produto adicionado ainda"
  >
    <!-- table content -->
    <template v-slot:item="{ item, expand, isExpanded, index }">
      <tr :class="{ repeated: addErrorClass(item.sku) }">
        <td>
          <div v-if="isMultipleEans(item)">
            <mf-button type="icon" size="sm" color="marca-1" :icon="isExpanded ? 'indeterminate_check_box' : 'add_box'" @click="expand(!isExpanded)" />
          </div>
        </td>

        <td>
          <div class="img-container d-flex align-center justify-center">
            <img v-if="item.image" :src="item.image" alt="" width="100%" />
            <mf-icon v-else>image_not_supported</mf-icon>
          </div>
        </td>

        <td>
          <span>{{ item.name }}</span>
        </td>

        <td>
          {{ item.sku }}
        </td>

        <td>
          <div class="py-0">
            <span v-if="item.product && item.product.eans && item.product.eans.length > 1">
              {{ getEansCount(item) }}
            </span>
            <span v-else style="word-break: keep-all">
              {{ item.eans[0] }}
            </span>
          </div>
        </td>

        <td>
          <mf-icon
            v-if="showDeleteProductIcon"
            type="icon"
            icon="delete"
            color="cinza-l30"
            style="cursor: pointer"
            :disabled="item.disabled || disabled"
            @click="$emit('remove-item', item)"
          />
        </td>
      </tr>
    </template>

    <template v-slot:expanded-item="{ headers, item }">
      <td class="expanded-itens" :colspan="headers.length">
        <v-checkbox
          v-for="ean in toSet(item.product.eans)"
          :key="ean"
          v-model="item.eans"
          :value="ean"
          :label="ean"
          :disabled="isCheckboxDisabled(ean, item.eans) || item.disabled || disabled"
          color="marca-1"
          multiple
        />
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { offerSalesTables } from '@/modules/campanhas/gestao-ofertas-v2/views/mixins/offer-sales-tables.js'
export default {
  name: 'CouponDiscountTable',
  mixins: [offerSalesTables],
  props: {
    showDeleteProductIcon: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    expanded: [],
    singleExpand: true,
  }),
  computed: {
    tableHeaders() {
      return [
        {
          text: '',
          value: 'expandAction',
          width: '2%',
          sortable: false,
        },
        {
          text: 'Imagem',
          value: 'image',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Nome',
          value: 'name',
          width: '30%',
          sortable: false,
        },
        {
          text: 'SKU',
          value: 'sku',
          width: '20%',
          sortable: false,
        },
        {
          text: 'EAN',
          value: 'ean',
          width: '36%',
          sortable: false,
        },
        {
          text: '',
          value: 'action',
          sortable: false,
          align: 'right',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep th {
  color: $cinza-d20 !important;
  font-size: 14px;
  font-weight: bold;
}

::v-deep tbody {
  td {
    color: $cinza-0;
    font-size: 14px;
    line-height: 1;
  }
}

.invalid-input {
  color: $vermelho-0;

  .field-padding {
    span {
      border: 1px #ff5252 solid !important;
      padding: 0 5px;
    }
  }
}

.expanded-itens {
  padding-left: 19%;
}

::v-deep .repeated {
  background-color: #ffc4c4;
  &:hover {
    background-color: #ffc4c4 !important;
  }
}

::v-deep th,
::v-deep td {
  padding: 0 8px;
}

.img-container {
  width: 35px;
  height: 35px;

  & img {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
